<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.model"
            :error-messages="modelErrors"
            :label="$t('profile.option.model')"
            required
            @input="$v.item.model.$touch()"
            @blur="$v.item.model.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, 1.0.0-ALPHA.1, 1.0.0-R.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.option.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>


      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6"  v-if="!item['@id']">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.parent"
            :items="optionSelectItems"
            :error-messages="parentErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('profile.option.parent')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.machine.machine')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="materialSupplySelectItems"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.setupdefinition.materialsupply')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolHeadSelectItems"
            v-model="item.toolHead"
            :items="toolHeadSelectItems"
            :error-messages="toolHeadErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.tool.toolhead')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.option"
            :items="optionSelectItems"
            :error-messages="optionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.option.option')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'OptionForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    //  this.optionGetSelectItems({'query'  : [{'id': 'exists[parent]', 'value': 0 }]  });
      this.optionGetSelectItems();
      this.machineGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.toolHeadGetSelectItems();
  },
  data() {
    return {
        model: null,
        version: null,
        parent: null,
        machine: null,
        materialSupply: null,
        toolhead: null,
        option: null,
        archive: null,
    };
  },
  computed: {

    isLoading() {
      return (this.isLoading_option ||
        this.isLoading_machine ||
        this.isLoading_materialSupply ||
        this.isLoading_toolHead
       );
    },
    ...mapFields('option', {
      optionSelectItems: 'selectItems',
      isLoading_option : 'isLoading'
    }),
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
      isLoading_machine : 'isLoading'
    }),
    ...mapFields('materialsupply', {
      materialSupplySelectItems: 'selectItems',
      isLoading_materialSupply : 'isLoading'
    }),
    ...mapFields('toolhead', {
      toolHeadSelectItems: 'selectItems',
      isLoading_toolHead : 'isLoading'
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    modelErrors() {
      const errors = [];

      if (!this.$v.item.model.$dirty) return errors;

      has(this.violations, 'model') && errors.push(this.violations.model);

      !this.$v.item.model.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    parentErrors() {
      const errors = [];

      if (!this.$v.item.parent.$dirty) return errors;

      has(this.violations, 'parent') && errors.push(this.violations.parent);


      return errors;
    },
    machineErrors() {
      const errors = [];
      if (!this.$v.item.machine.$dirty) return errors;
      has(this.violations, 'machine') && errors.push(this.violations.machine);
      return errors;
    },
    materialSupplyErrors() {
      const errors = [];
      if (!this.$v.item.materialSupply.$dirty) return errors;
      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);
      return errors;
    },
    toolHeadErrors() {
      const errors = [];
      if (!this.$v.item.toolHead.$dirty) return errors;
      has(this.violations, 'toolHead') && errors.push(this.violations.toolHead);
      return errors;
    },
    optionErrors() {
      const errors = [];
      if (!this.$v.item.option.$dirty) return errors;
      has(this.violations, 'option') && errors.push(this.violations.option);
      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        optionGetSelectItems: 'option/fetchSelectItems'
      }),
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
      ...mapActions({
        toolHeadGetSelectItems: 'toolhead/fetchSelectItems'
      }),

  },
  validations: {
    item: {
      model: {
        required,
      },
      version: {
        required,
      },
      parent: {
      },
      machine: {
      },
      materialSupply: {
      },
      toolHead: {
      },
      option: {
      },
      archive: {
      },
    }
  }
};
</script>
